export default "__VITE_ASSET__1wyZvWtL__"